import * as React from 'react';

import { IconSolidStar } from '@notino/react-styleguide';

import { IReviewSummary } from '@containers/ProductDetailContainer/model';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { normalizeCategory } from '../../ReviewItems/SortFilterBar/Filters/helpers';
import { trackFiltration } from '../../ReviewItems/SortFilterBar/Filters/tracking';
import {
  useReviewFilterActions,
  useReviewFiltersStore,
} from '../../ReviewItems/SortFilterBar/Stores/filtersStore';
import { RatingRow } from '../styled';

import {
  ProgressWrapper,
  RatingsValue,
  StarsBox,
  StarsValue,
  StarReviews,
  StyledProgressBar,
  ReviewsCount,
} from './styled';

interface IStarSummaryProps {
  reviewSummary: IReviewSummary;
}

export const StarsSummary: React.FC<IStarSummaryProps> = ({
  reviewSummary,
}) => {
  const selectedCategory = useReviewFiltersStore(
    (state) => state.currentCategory
  );

  const { selectSingleRating } = useReviewFilterActions();
  const { getTimeFromInit } = useTrackingContext();

  const onRatingClick = (star) => {
    selectSingleRating(Number(star));

    trackFiltration({
      interaction: 'filtration_quick_use',
      timing: getTimeFromInit(),
      name: '',
      action: 'filtration_quick_used',
      type: selectedCategory ? normalizeCategory(selectedCategory) : undefined,
    });
  };

  const votesWithDefaults = {
    5: 0,
    4: 0,
    3: 0,
    2: 0,
    1: 0,
    ...reviewSummary.votes,
  };

  return (
    <StarReviews data-cypress="reviews-starsSummary">
      {Object.keys(votesWithDefaults)
        .sort()
        .reverse()
        .map((stars) => (
          <RatingRow
            key={stars}
            onClick={() => onRatingClick(stars)}
            hasHover={true}
          >
            <RatingsValue>
              <StarsValue>{stars}</StarsValue>
              <StarsBox>
                <IconSolidStar
                  width="14px"
                  height="14px"
                  color="icon.primary"
                />
              </StarsBox>
            </RatingsValue>
            <ProgressWrapper>
              <StyledProgressBar
                name={stars}
                max={reviewSummary.totalVotes}
                value={votesWithDefaults[stars]}
                height={4}
              />
              <ReviewsCount>{votesWithDefaults[stars]}</ReviewsCount>
            </ProgressWrapper>
          </RatingRow>
        ))}
    </StarReviews>
  );
};
